export const commercialListFixedDealLocalTxt = $localize`:commercialList|Commercial List Header Fixed Deal
      Label@@commercialListHeaderFixedDealLabel:Fixed Deal`;
export const commercialListCustomisableUpwardsLocalTxt = $localize`:commercialList|Commercial List Header Customisable Upwards
      Label@@commercialListHeaderCustomisableUpwardsLabel:Customisable Upwards`;
